import React from 'react';
import { Paper } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { ServiceButton } from '../core/Button';
import { CONTACT } from './routing';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  paper: {
    border: `solid thin #FD591F`,
  },
  paperInner: {
    width: '100%',
    margin: 0,
    '& > *': {
      padding: theme.spacing(3, 2),
      [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(5, 4),
      },
    },
  },
  buttonItem: {
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(0, 2, 3),
    },
  },
  button: {
    padding: theme.spacing(2),
  },
}));

const ContactGrid = ({ children }) => {
  const classes = useStyles();
  return (
    <Grid container>
      <Paper square elevation={0} className={classes.paper}>
        <Grid container className={classes.paperInner} alignItems="center">
          <Grid item md={8} xs={12}>
            <Typography>{children}</Typography>
          </Grid>
          <Grid item md={4} xs={12} className={classes.buttonItem}>
            <ServiceButton
              variant="contained"
              color="primary"
              href={CONTACT}
              className={classes.button}
            >
              お問い合わせ
            </ServiceButton>
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  );
};

export default ContactGrid;
